import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '../../base/Grid';

import {
  GeneralSection,
} from './styles';

export const SectionContainerComponent = ({
  id,
  variant,
  children,
}) => (
  <GeneralSection id={`${id}-section-container`} variant={variant}>
    <Container>
      {children}
    </Container>
  </GeneralSection>
);

SectionContainerComponent.propTypes = {
  /** Id for the section */
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  /** Children components placed inside the section */
  children: PropTypes.any.isRequired,
};

SectionContainerComponent.defaultProps = {
  variant: 'primary',
};

export default SectionContainerComponent;
